/** Veigar AbilitySpec seed kit (wiki-aligned geometry / costs). */
import {
  VEIGAR_E_CC_DURATION_SEC,
  VEIGAR_E_COOLDOWN,
  VEIGAR_E_DURATION_SEC,
  VEIGAR_E_EFFECT_DELAY_SEC,
  VEIGAR_E_INNER,
  VEIGAR_E_MANA,
  VEIGAR_E_OUTER,
  VEIGAR_E_RANGE,
  VEIGAR_Q_MANA,
  VEIGAR_Q_RADIUS,
  VEIGAR_Q_RANGE,
  VEIGAR_Q_SPEED,
  VEIGAR_Q_WIDTH,
  VEIGAR_R_COOLDOWN,
  VEIGAR_W_COOLDOWN,
  VEIGAR_W_EFFECT_DELAY_SEC,
  VEIGAR_W_MANA,
  VEIGAR_W_RADIUS,
  VEIGAR_W_RANGE
} from '../params/veigarParams.js';

export const VEIGAR_ABILITY_DEFS = [
  {
    id: 'veigar_q',
    champKey: 'veigar',
    slot: 'Q',
    name: 'Baleful Strike',
    targeting: 'skillshot_line',
    range: VEIGAR_Q_RANGE,
    castTime: 0.25,
    travelSpeed: VEIGAR_Q_SPEED,
    width: VEIGAR_Q_WIDTH,
    radius: VEIGAR_Q_RADIUS,
    cooldown: 6,
    manaCost: VEIGAR_Q_MANA,
    vfxId: 'veigar_q',
    damageType: 'magic',
    spellEffects: 'spell',
    projectile: true,
    status: 'wired'
  },
  {
    id: 'veigar_w',
    champKey: 'veigar',
    slot: 'W',
    name: 'Dark Matter',
    targeting: 'ground_aoe',
    range: VEIGAR_W_RANGE,
    castTime: 0.25,
    effectDelay: VEIGAR_W_EFFECT_DELAY_SEC,
    radius: VEIGAR_W_RADIUS,
    cooldown: VEIGAR_W_COOLDOWN,
    manaCost: VEIGAR_W_MANA,
    vfxId: 'veigar_w',
    damageType: 'magic',
    spellEffects: 'spell',
    status: 'wired'
  },
  {
    id: 'veigar_e',
    champKey: 'veigar',
    slot: 'E',
    name: 'Event Horizon',
    targeting: 'ground_aoe',
    range: VEIGAR_E_RANGE,
    castTime: 0.25,
    effectDelay: VEIGAR_E_EFFECT_DELAY_SEC,
    duration: VEIGAR_E_DURATION_SEC,
    innerRadius: VEIGAR_E_INNER,
    radius: VEIGAR_E_OUTER,
    cooldown: VEIGAR_E_COOLDOWN,
    manaCost: VEIGAR_E_MANA,
    vfxId: 'veigar_e',
    cc: { type: 'stun', duration: VEIGAR_E_CC_DURATION_SEC },
    status: 'wired'
  },
  {
    id: 'veigar_r',
    champKey: 'veigar',
    slot: 'R',
    name: 'Primordial Burst',
    targeting: 'targeted',
    range: 650,
    castTime: 0.25,
    cooldown: VEIGAR_R_COOLDOWN,
    manaCost: 100,
    vfxId: 'veigar_r',
    damageType: 'magic',
    spellEffects: 'spell',
    status: 'wired'
  }
];
